// control flow
import * as Redux from 'redux'
import * as ReactRedux from 'react-redux'
import * as Sagas from 'redux-saga'
import * as SagaEffects from 'redux-saga/effects'

// rendering
import React from 'react'
import Media from 'react-media'
import TWEEN from '@tweenjs/tween.js'

// macguffin things
import Main from './Main'
import * as Components from './components'
import Sounds from './Sounds'
import Utils from './Utils'
import Currency from './Utils/Currency'
import * as feim from '@rlx/feim'

import Reducers from './redux/reducers'
import Constants from './redux/constants'
import * as Actions from './redux/actions'
import createReducer from './redux/createReducer'

const { connect } = ReactRedux

const GameState = {
  Redux,
  ReactRedux,
  Sagas,
  SagaEffects,
  Reducers,
  Constants,
  Actions,
  createReducer
}


const Rendering = {
  React,
  Media,
  TWEEN,
}

const { Component } = Components

module.exports = {
  Main,
  feim,

  // state
  GameState,
  connect,

  // rendering
  Rendering,

  // macguffin things
  Components,
  Component,
  Sounds,
  Utils,
  Currency,
}
